export const LIVE_PAGE_SOURCE = 'live-page' as const;
